"use client";
import { cities } from "@repo/constants/cities";
import { useLocale } from "next-intl";
const SelectCity = ({
  value,
  label,
  name,
  onChange,
  disabled,
  defaultValue,
}) => {
  const locale = useLocale();
  return (
    <>
      {label && (
        <label
          htmlFor="select-field"
          className="mb-2 block text-sm font-medium text-[#5E5E5E]"
        >
          {label}
        </label>
      )}
      <select
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="border-supportiveDarkGray text-supportiveBlack focus:outline-icon-color block h-9 w-full border px-4 pe-8 text-sm font-medium focus:border-gray-500 focus:bg-white md:h-11"
      >
        <option value="">{defaultValue}</option>
        {cities?.map((option) => (
          <option key={option.id} value={option.city_en}>
            {locale === "ar" ? option.city_ar : option.city_en}
          </option>
        ))}
      </select>
    </>
  );
};

export default SelectCity;
